import { Routes, Route } from "react-router-dom";
// import "react-toastify/dist/ReactToastify.css";
import Booking from "./Components/pages/Booking";
import Documents from "./Components/pages/Documents";
import Login from "./Components/pages/Login";
import BookingList from "./Components/pages/BookingList";
import Payment from "./Components/pages/Payment";
import Success from "./Components/pages/Success";
import OTPVerify from "./Components/pages/OTPVerify";
function App() {
  return (
    <Routes>
      <Route path="/" element={<Login />}></Route>
      <Route path="/otp-verify" element={<OTPVerify />}></Route>
      <Route path="/all-booking" element={<BookingList />}></Route>
      <Route path="/booking/:id" element={<Booking />}></Route>
      <Route path="/kyc-documents/:id" element={<Documents />}></Route>
      <Route path="/payment/:id" element={<Payment />}></Route>
      <Route path="/paymentstatus" element={<Success />}></Route>
    </Routes>
  );
}

export default App;
